import { TitleAndDescription } from "@components/_Revamp/TitleAndDescription";
import MainContainer from "@pages/EverGreen/Components/Container";
import { Title } from "@components/_Revamp/Typography/Title.stories";
import { ROUTE_PATH } from "@static/route-paths";
import React, { useCallback, useEffect, useLayoutEffect, useState } from "react";
import { styled } from "@linaria/react";
import InnerContainer from "@pages/EverGreen/Components/InnerContainer";
import { EverGreenStyle } from "@utils/Style/everGreen";
import Button from "@pages/EverGreen/Components/Button";
import { InputGroup } from "@components/_Revamp/InputGroup";
import { PRODUCT_CODE_API, postValidateAdviser } from "@api/index";
import { useAvivaDispatch, useAvivaSelector } from "@redux/hook";
import {
  IFARresponse,
  updateAssignedAgentOption,
  updateFinancialAdviser,
  updateFARData,
} from "@redux/slices/EVER_GREEN/step3Slice";
import { mask } from "@utils/mask";
import { LoadingScreen } from "@utils/helpers";
import Accordion from "@components/_Revamp/Accordion";
import { css } from "@linaria/core";
import { Text } from "@components/_Shared/Text";
import Bullet from "@components/_Revamp/Bullet";
import { useHistory } from "react-router-dom";
import { SCREEN_SIZE } from "@static/screen-size";
import { trackOnFormStartOrSuccess, trackOnLoad } from "@pages/EverGreen/Helpers/analyticsHelper";

export const Mapper: Record<string, string> = {
  "no-adviser": "NO_AGENT",
  "singlife-adviser": "ARISTOTLE",
  "own-adviser": "USER_PREFERRED",
};

function FinancialAdviser() {
  const [adviserName, setAdviserName] = useState("");
  const [error, setError] = useState("");
  const selectedOption = useAvivaSelector(
    (state) => state.everGreenStep3.financialAdviser.autoAssignAgent
  );
  const adviser = useAvivaSelector(
    (state) => state.everGreenStep3.financialAdviser.adviserData
  );
  const isPEP = useAvivaSelector((s) => s.everGreenStep3.PEP.isPEP);
  const fcc = useAvivaSelector((state) => state.everGreenStep3.occupation.fcc);
  const customerId = useAvivaSelector(
    (state) => state.everGreenStep2.myInfo.customerId
  );
  const declarationAcceptance = useAvivaSelector(
    (state) => state.everGreenStep3.declarationAcceptance
  );
  const farData = useAvivaSelector((state) => state.everGreenStep3.FARData);
  const campaignData = useAvivaSelector(state=>state.loading.campaignDetail)
  const dispatch = useAvivaDispatch();
  const [farCode, setFarCode] = useState(farData.code || "");
  const history = useHistory();

  // Get the FAR name and details from the store

  const FAROptionHandler: React.MouseEventHandler<HTMLDivElement> = useCallback(
    async (e) => {
      trackOnFormStartOrSuccess("DS_financial_adviser_form")
      const option = e.target as HTMLDivElement;
      dispatch(updateAssignedAgentOption(option?.getAttribute("data-far")!));
      dispatch(updateFARData({ isNeed: selectedOption }));
      if (option?.getAttribute("data-far")! === "own-adviser") {
        return;
      }
      validateFarCode(option);
    },
    [selectedOption]
  );

  const validateFarCode = async (option?: HTMLDivElement) => {
    try {
      LoadingScreen();
      const agentSelectedType =
        Mapper[
          (option?.getAttribute && option?.getAttribute("data-far")) ||
            "own-adviser"
        ];
      const payload = {
        agentCode: farCode.replaceAll(" ","") || "",
        clientNo: "",
        loggedInUserId: 0,
        loginUser: "",
        requesterClientNumber: "",
        sourceSystem: "evergreen",
        agentSelectedType,
        customerId: Number(customerId),
      };
      const { data } = await postValidateAdviser(
        farCode.replaceAll(" ","") ,
        PRODUCT_CODE_API.EVER_GREEN,
        payload
      );
      //   const data = {
      //     "status": true,
      //     "responseErrorDetail": null,
      //     "totalPages": 0,
      //     "totalItems": 0,
      //     "logoutUser": false,
      //     "data": {
      //         "clientNum": "01436194",
      //         "clientType": "P",
      //         "surname": "LOO",
      //         "givname": "Wwllwqm",
      //         "salutation": "Mr",
      //         "fullName": "Lxm Wwllwqm",
      //         "nric": "T1241581D",
      //         "dob": "19731010",
      //         "gender": "Male",
      //         "maritalStatus": "Unknown",
      //         "nationality": "Singapore",
      //         "race": "Chinese",
      //         "homeNum": "0000000001",
      //         "mobileNum": "6597734748",
      //         "officeNum": "0000000002",
      //         "faxNum": null,
      //         "emailId": "aaronyh_gan@singlife.com",
      //         "residential_Addr_1": null,
      //         "residential_Addr_2": null,
      //         "residential_Addr_3": null,
      //         "residential_Addr_4": null,
      //         "residential_Addr_5": null,
      //         "residentialAddrCountry": "Singapore",
      //         "residentialAddrPostalCode": "999999",
      //         "agentTerminatedFlag": "N",
      //         "agentSourceOfBusiness": "BRK"
      //     }
      // } as unknown as IFARresponse
      if (["NO_AGENT", "ARISTOTLE"].includes(agentSelectedType)) {
        return;
      }
      if (
        data?.data &&
        data?.data?.fullName &&
        data?.data?.agentTerminatedFlag !== "Y"
      ) {
        //update the store
        if (data?.data?.fullName) {
          data.data.fullName = mask(data?.data?.fullName);
        }
        dispatch(updateFinancialAdviser(data));
        const agentName = data?.data?.fullName;
        setAdviserName(
          `${agentName} has been assigned as your Financial Adviser Representative for this policy`
        );
        setError("");
      } else {
        setAdviserName("");
        setError(
          "We couldn't find an adviser with the code you provided. Try another code."
        );
        dispatch(updateFinancialAdviser({ data: null }));
      }
    } catch (e) {
      //TODO update the error screen route
      trackOnLoad({errorPage:{errorCode:"500", errorMsg:"adviser validation api called failed"}})
      history.push(ROUTE_PATH.EVER_GREEN_CONTACTUS); 

      console.error(e);
    } finally {
      LoadingScreen(false);
    }
  };

  const disbaleBtn = () => {
    if ((isPEP === "YES" || fcc === "YES") && selectedOption === "no-adviser") {
      return true;
    }
    return Boolean(
      !selectedOption ||
        (selectedOption === "own-adviser" &&
          (!adviser?.data?.fullName ||
            adviser?.data?.agentTerminatedFlag === "Y" ||
            !!error))
    );
  };

  useLayoutEffect(() => {
    if(campaignData?.product === "DIGITALSAVER" ){
      history.replace(ROUTE_PATH.EVER_GREEN_REVIEW)
    }

  },[]);

  useEffect(() => {
    // for ARC
    async function fetcher() {}
    fetcher();
    if (
      adviser.data?.fullName &&
      adviser.data.agentTerminatedFlag !== "Y" &&
      farData.code
    ) {
      const agentName = mask(adviser?.data?.fullName);
      setAdviserName(
        `${agentName} has been assigned as your Financial Adviser Representative for this policy`
      );
    }
  }, []);

    //AA on load
    useEffect(()=>{
  if (!declarationAcceptance) return;
      trackOnLoad()
    },[])

  if (!declarationAcceptance) {
    history.replace(ROUTE_PATH.EVER_GREEN_DOCUMENT_REVIEW);
    return null;
  }

  return (
    // TODO update the back button route
    <MainContainer
      backButtonPath={ROUTE_PATH.EVER_GREEN_DOCUMENT_REVIEW}
      step={3}
    >
      <InnerContainer>
        <div style={{ maxWidth: "588px", margin: "auto" }}>
          <Title variant="title" align="center">
            Do you need a Financial Adviser Representative to service this
            policy?
          </Title>
        </div>
        <ButtonNFarSearch>
          <ButtonContainer>
            {!(isPEP === "YES" || fcc === "YES") && (
              <RectSelector
                data-far="no-adviser"
                isSlected={selectedOption === "no-adviser"}
                onClick={FAROptionHandler}
              >
                No, I do not need an adviser
              </RectSelector>
            )}
            <RectSelector
              data-far="singlife-adviser"
              isSlected={selectedOption === "singlife-adviser"}
              onClick={FAROptionHandler}
            >
              Yes, assign an adviser to me
            </RectSelector>
            <RectSelector
              data-far="own-adviser"
              isSlected={selectedOption === "own-adviser"}
              onClick={FAROptionHandler}
            >
              Yes, I want to assign my own adviser
            </RectSelector>
          </ButtonContainer>
          <FARSearchContainer isShow={selectedOption === "own-adviser"}>
            <div>
              <div>
                <InputGroup
                  id="far-code"
                  inputProps={{
                    textAlign: "left",
                    value: farCode,
                  }}
                  theme={themeCustom}
                  onChange={(e) =>
                    setFarCode((prev) => {
                      if (e.target.value.length > 9) {
                        return prev;
                      }
                      let input = e.target.value.trim();
                      const regex = /^[0-9]{0,4}\s{0,1}[0-9]{0,4}$/;
                      if (!regex.test(input)) {
                        return prev;
                      }
                      if (input.includes(" ")) {
                        input = input.slice(0, 4) + " " + input.slice(5);
                      } else if (input.length > 4) {
                        input = input.slice(0, 4) + " " + input.slice(4);
                      }
                      dispatch(updateFARData({ code: input?.replaceAll(" ","") || input }));
                      return input;
                    })
                  }
                  inputType="input"
                  label="Financial Adviser Representative Code"
                />
                {adviserName && (
                  <div className="adviser-res">{adviserName}</div>
                )}
                {error && (
                  <div className="adviser-res adviser-error">{error}</div>
                )}
              </div>
              <Button
                label="Find adviser"
                disabled={farCode.length < 9}
                data-far="own-adviser"
                onClick={validateFarCode}
                theme={EverGreenStyle}
                variant="secondary"
              />
            </div>
          </FARSearchContainer>
        </ButtonNFarSearch>
      </InnerContainer>
      <ContinueContainer>
        <Button
          theme={EverGreenStyle}
          width="180px"
          onClick={() => {
           trackOnFormStartOrSuccess("DS_financial_adviser_form", true)

            history.push(ROUTE_PATH.EVER_GREEN_REVIEW);
          }}
          disabled={disbaleBtn()}
          label="Continue"
        />
      </ContinueContainer>
      <div>
        <Accordion {...accordionArgs}>
          <div style={{ paddingBottom: "20px" }}>
            <Bullet>
              <Text variant="base" fontSize="12px">
                If you are an existing Singlife customer, we'll assign the
                latest active representative, either from Singapore Life Ltd. or
                from our distribution partners, who has been servicing your
                policy.
              </Text>
            </Bullet>
            <Bullet>
              <Text variant="base" fontSize="12px">
                If you are a new customer of Singlife or don't have an active
                representative who have sold a Singlife plan to you, we'll
                assign a dedicated Singlife Relationship Consultant.
              </Text>
            </Bullet>
          </div>
          <Text variant="base" fontSize="12px" padding="0 0 20px">
            Once you've completed your purchase, we'll email you the details of
            the assigned Financial Adviser Representative who will be servicing
            your policy.
          </Text>
        </Accordion>
      </div>
    </MainContainer>
  );
}

const ContinueContainer = styled.div`
  margin: 64px auto;
  display: flex;
  justify-content: center;
`;

const ButtonContainer = styled.div`
  width: 100%;
  margin-top: 64px;
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
const FARSearchContainer = styled.div<{ isShow: boolean }>`
  width: 100%;
  margin-top: 24px;
  height: ${(props) => (props.isShow ? "100%" : "0px")};
  overflow: hidden;
  transition: all 0.3s linear;
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    height: ${(props) => (props.isShow ? "120px" : "0px")};
  }
  div {
    width: 100%;
    @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
      display: flex;
    }
    div:first-child {
      flex: 2;
      display: flex;
      flex-direction: column;
      div > label {
        margin-bottom: 10px;
      }
      .adviser-res {
        color: #19d3c5;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        padding-bottom: 10px;
        line-height: 140%; /* 16.8px */
        letter-spacing: 0.18px;
        margin-top: 8px;
        @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
          margin-bottom: 10px;
        }
      }
      .adviser-error {
        color: #c50000;
      }
    }
    button {
      flex: 1;
      margin-top: 25px;
      @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
        margin-top: 10px;
        margin-left: 24px;
      }
    }
  }
`;
const ButtonNFarSearch = styled.div`
  max-width: 664px;
  padding: 0px 20px;
  margin: auto;
`;

const RectSelector = styled.div<{ isSlected: boolean }>`
  max-width: 616px;
  font-size: 14px;
  width: inherit;
  border-radius: 8px;
  text-align: center;
  padding: 15px 24px;
  margin: auto 20px;
  font-weight: 600;
  background-color: ${(props) =>
    props.isSlected
      ? EverGreenStyle.colors.primary
      : EverGreenStyle.colors.grey[700]};
  color: ${(props) =>
    props.isSlected
      ? EverGreenStyle.colors.white
      : EverGreenStyle.colors.grey[1200]};
  transition: background-color 0.2s linear;
  cursor: pointer;
  &:hover {
    background-color: ${EverGreenStyle.colors.primary};
    color: ${EverGreenStyle.colors.white};
  }
`;

const themeCustom = JSON.parse(JSON.stringify(EverGreenStyle));
themeCustom.colors.primary = "#000";

const container_default_css = css`
  margin-bottom: 130px;
`;

const title_default_css = css`
  font-family: "Open Sans";
  color: #434343;
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  @media screen and (max-width: 768px) {
    width: unset;
    font-size: 16px;
  }
`;

const accordionArgs = {
  title:
    "Things to note when we assign a Financial Adviser Representative to you:",
  theme: EverGreenStyle,
  className: container_default_css,
  titleClassName: title_default_css,
  headerPadding: "24px 24px 24px 0",
  titleFontSize: 14,
  isExpanded: true,
  showBottomLine: true,
  showHeaderLine: true,
  bottomLineColor: "#c4c4c4",
  bottomLineThickness: "1px",
  contentMarginLeft: "0px",
  contentMarginRight: "0px",
  bottomLineClassName: "margin:10px",
  headerBackgroundColor: "#F4F6F9",
  showHeaderBackground: true,
};

export default FinancialAdviser;
